import Vue from 'vue'
import App from './App.vue'
import router from './router/index'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import Print from 'vue-print-nb'
Vue.use(Print);
Vue.use(ElementUI)
import '../static/css/main.css'
import store from './store/index'
import Cookies from 'js-cookie'
import VueEsign from 'vue-esign';
Vue.use(VueEsign);

// 全局公共接口api
Vue.prototype.$api = require('./api/index').default

// 图片压缩
Vue.prototype.$compress = require('./api/compress').default

Vue.prototype.$isNumber = function(i){
	return i === 0 ? !1 : isNaN(i) ? !0 : i < 0 || i == '' ? !0 : false;
}
Vue.prototype.$isNumber1 = function(i){
	return isNaN(i) ? !0 : i < 0 || i == '' ? !0 : false;
}
Vue.prototype.$totalPrice = function(n){
	var fraction = ['角', '分'];
	var digit = [
			'零', '壹', '贰', '叁', '肆',
			'伍', '陆', '柒', '捌', '玖'
	];
	var unit = [
			['元', '万', '亿'],
			['', '拾', '佰', '仟']
	];
	var head = n < 0 ? '欠' : '';
	n = Math.abs(n);
	var s = '';
	for (var i = 0; i < fraction.length; i++) {
			s += (digit[Math.floor(n * 10 * Math.pow(10, i)) % 10] + fraction[i]).replace(/零./, '');
	}
	s = s || '整';
	n = Math.floor(n);
	for (var i = 0; i < unit[0].length && n > 0; i++) {
			var p = '';
			for (var j = 0; j < unit[1].length && n > 0; j++) {
					p = digit[n % 10] + unit[1][j] + p;
					n = Math.floor(n / 10);
			}
			s = p.replace(/(零.)*零$/, '').replace(/^$/, '零') + unit[0][i] + s;
	}
	return head + s.replace(/(零.)*零元/, '元')
			.replace(/(零.)+/g, '零')
			.replace(/^整$/, '零元整');
}

Vue.prototype.$keepAlive = function(t,url, off){
	t.$router.options.routes.map(i=>{
		if(i.path === url){
			i.meta.keepAlive = off;
		}
	})
}

Vue.config.productionTip = false;

var vue = new Vue({
	router,
	store,
	render: h => h(App),
}).$mount('#app')
export default vue

router.afterEach(function (to, from) {
	let date = new Date();
	store.state.theDay = date.getFullYear() +'-'+ (date.getMonth()+1) +'-'+ date.getDate();
	document.title = to.meta.title;
	if(to.path != '/login'){
		if(Cookies.get('SHANGYI_TOKEN') == undefined){
			vue.$router.push('/login')
		}else{
			store.state.token = Cookies.get('SHANGYI_TOKEN');
			store.state.profile = JSON.parse(Cookies.get('SHANGYI_PROFILE'));
		}
	}
})



// WEBPACK FOOTER //
// ./src/main.js